import {AuthService} from 'compob2b-auth';
import {environment} from '../environments/environment';
import {ApiResponse, InitData} from 'compob2b-libs';
import {Injector} from '@angular/core';
import {Router} from '@angular/router';
import {routes} from './cabinet/cabinet.routing.module';
import {showCaseRoutes} from './cabinet/showcase.routing.module';
import {UtilsService} from './cabinet/utils/utils.service';


/**
 * Get tokens, menu and other settings for anonymous user
 * before application initialized
 * i.e. one user gave a link to another one and we need to
 * identify and authenticate another one as anonymous
 * if the user doesn't authorize
 * @param auth AuthService
 */
export function init(
  auth: AuthService
): () => Promise<ApiResponse<InitData> | Error> {
  return () => {
    if (environment.isOpenCabinet === true) {
      if (auth.isCustomer() || auth.isManager()) {
        return auth.initCustomer().toPromise();
      }

      const isAnonymous = auth.checkAndSetAnonymousToken();
      if (isAnonymous !== null) {
        return isAnonymous.toPromise();
      }
    }
  };
}

export function loadRoutes(injector: Injector) {
  return () => {
    const currentRoute = UtilsService.isCurrentDomainShowcase() ? showCaseRoutes : routes;

    let filteredRoutes = currentRoute.map(route => {
      if (route.children) {
        route.children = route.children.filter(route => {
          console.log(route.data);
          return route.data?.modules == null || isPresent(route);
        });
      }

      return route;
    });

    const router: Router = injector.get(Router);
    router.resetConfig(filteredRoutes);
  };
}

function isPresent(route) {
  for (const property in environment?.loadedRoutes) {
    if (
      // В роуте существует в блоке data свойство с именем из environment.loadedRoutes.property
      route.data?.modules.hasOwnProperty(property) &&
      // Значение в роуте из data.module.property равно значению из конфига environment.loadedRoutes.property
      route.data?.modules[property] === environment.loadedRoutes[property]
    )
      return true;
  }
  return false;
}
